import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initPixel, trackPixel } from '../utils/pixel';

/** Inicializa el Meta Pixel y registra un PageView en cada cambio de página. */
export function PixelTracker() {
  const {
    pathname,
    search
  } = useLocation();
  useEffect(() => {
    initPixel();
  }, []);
  useEffect(() => {
    trackPixel('PageView');
  }, [pathname, search]);
  return null;
}